export default __webpack_public_path__ + "static/media/Sprint.99ac9174.svg";